import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '../containers/Full'

// Views
import MapType from '../views/MapType'
import Site from '../views/Site'
import SiteVersion from '../views/SiteVersion'
import DataFile from '../views/DataFile'
import Login from '../pages/Login'

import store from '../store'

Vue.use(Router)

const requireAuth = (returnPath) => (from, to, next) => {
  let accessToken = store.getters.accessToken
  if (accessToken) return next()
  else next('/pages/login?returnPath=' + returnPath)
}

const reload = () => (from, to, next) => {
  let message = "데이터 파일 설정 중 'eTileType' 파일을 변경한 경우 서버의 데이터 파일 갱신 작업이 필요합니다. ('eDBType' 파일 변경은 갱신 작업이 필요없음)\n\n지금 변경한 데이터 파일 설정을 갱신하시겠습니까 ?"
  if (confirm(message)) {
    Vue.prototype.$http.get('/setting/admins/reload')
      .then((response) => {
        Vue.prototype.$toasted.global.success('데이터 파일 갱신작업이 성공적으로 완료되었습니다.')
      })
      .catch((error) => {
        Vue.prototype.$toasted.global.error('데이터 파일 갱신작업에 실패하였습니다. (' + error.message + ')')
      })
  }
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dataFile',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'mapType',
          name: 'MapType',
          component: MapType,
          beforeEnter: requireAuth('mapType')
        },
        {
          path: 'site',
          name: 'Site',
          component: Site,
          beforeEnter: requireAuth('site')
        },
        {
          path: 'siteVersion',
          name: 'SiteVersion',
          component: SiteVersion,
          beforeEnter: requireAuth('siteVersion')
        },
        {
          path: 'dataFile',
          name: 'DataFile',
          component: DataFile,
          beforeEnter: requireAuth('dataFile')
        },
        {
          path: 'reload',
          name: 'Reload',
          beforeEnter: reload()
        }
      ]
    },
    {
      path: '/pages',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js